const firstSlide = {
  images: [
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-original-2090-mobile-crop-left.jpg`,
      "414w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-original-2090.jpg`,
      "768w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-original-2090.jpg`,
      "1440w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-original-2090.jpg`,
      "1800w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-original-2090.jpg`,
      "2200w",
    ],
  ],
  url: "https://www.walmart.com/ip/ScotchBlue-Original-Painter-s-Tape-Blue-0-94-in-x-60-yd-1-Roll/14698521",
  firstCopy: "ScotchBlue™ Original Painter's Tape",
  secondCopy: "Mutli-Surface, Indoor & Outdoor",
  logo: `${process.env.MEDIA_URL}/media/images/logo-3-m-red.svg`,
};

const secondSlide = {
  images: [
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-sharp-lines-2093-mobile-crop-left.jpg`,
      "414w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-sharp-lines-2093.jpg`,
      "768w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-sharp-lines-2093.jpg`,
      "1440w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-sharp-lines-2093.jpg`,
      "1800w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/blue-sharp-lines-2093.jpg`,
      "2200w",
    ],
  ],
  url: "https://www.walmart.com/ip/ScotchBlue-Sharp-Lines-Painter-s-Tape-Blue-1-88-in-x-60-yd-1-Roll/16609866",
  firstCopy: "ScotchBlue™ Sharp Lines Painter's Tape",
  secondCopy: "Mutli-Surface, Indoor & Outdoor",
  logo: `${process.env.MEDIA_URL}/media/images/logo-3-m-red.svg`,
};

const thirdSlide = {
  images: [
    [
      `${process.env.MEDIA_URL}/media/images/carousel/delicate-surface-2080-mobile-crop-left.jpg`,
      "414w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/delicate-surface-2080.jpg`,
      "768w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/delicate-surface-2080.jpg`,
      "1440w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/delicate-surface-2080.jpg`,
      "1800w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/delicate-surface-2080.jpg`,
      "2200w",
    ],
  ],
  url: "https://www.walmart.com/ip/Scotch-Delicate-Surface-Painter-s-Tape-1-41-in-x-60-yd-1-Roll/20370773",
  firstCopy: "Scotch® Delicate Surface Painter's Tape",
  secondCopy: "Gentle Removal, Indoor",
  logo: `${process.env.MEDIA_URL}/media/images/logo-3-m-red.svg`,
};

const fourthSlide = {
  images: [
    [
      `${process.env.MEDIA_URL}/media/images/carousel/rough-surface-2060-mobile-crop-left.jpg`,
      "414w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/rough-surface-2060.jpg`,
      "768w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/rough-surface-2060.jpg`,
      "1440w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/rough-surface-2060.jpg`,
      "1800w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/rough-surface-2060.jpg`,
      "2200w",
    ],
  ],
  url: "https://www.walmart.com/ip/Scotch-Rough-Surface-Painter-s-Tape-1-41-in-x-60-1-yd-1-Roll/20370772",
  firstCopy: "Scotch® Rough Surface Painter's Tape",
  secondCopy: "Extra Strength, Indoor & Outdoor",
  logo: `${process.env.MEDIA_URL}/media/images/logo-3-m-red.svg`,
};

const fifthSlide = {
  images: [
    [
      `${process.env.MEDIA_URL}/media/images/carousel/exterior-surface-2097-mobile-crop-left.jpg`,
      "414w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/exterior-surface-2097.jpg`,
      "768w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/exterior-surface-2097.jpg`,
      "1440w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/exterior-surface-2097.jpg`,
      "1800w",
    ],
    [
      `${process.env.MEDIA_URL}/media/images/carousel/exterior-surface-2097.jpg`,
      "2200w",
    ],
  ],
  url: "https://www.walmart.com/ip/Scotch-Exterior-Surface-Painter-s-Tape-1-41-in-x-45-yd-1-Roll/35930757",
  firstCopy: "Scotch® Exterior Surface Painter's Tape",
  secondCopy: "Weatherproof, Outdoor",
  logo: `${process.env.MEDIA_URL}/media/images/logo-3-m-red.svg`,
};

const carousel: any = {
  slides: [firstSlide, secondSlide, thirdSlide, fourthSlide, fifthSlide],
};

export default carousel;
